import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import "../../CSS/general.css";
import { loginAuthProvider } from "../../LoginAuthProvider";
import LogRocket from "logrocket";
import AdminLogs from "../Pages/AdminLogs";
import AuthenticationContext from "../../Store/Authentication-Context";
export class EventLogs extends Component {
    static contextType = AuthenticationContext;
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            orgId: "",
            isValid: false,
        };
        this.validateToken = this.validateToken.bind(this);

    }
    static displayName = EventLogs.name;
    componentDidMount() {
        this.validateToken();
        const { setBranding } = this.context;
        setBranding(sessionStorage.getItem("ManageOrgId"), sessionStorage.getItem("ManageOrgName"));
    }
    async validateToken(event) {
        if (event) {
            event.preventDefault();
        }
        const { setAuthContext } = this.context;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        await Axios.get(API_ROUTE + Routes.VALIDATE_TOKEN_ADMIN, config)
            .then((response) => {

                let isValid = JSON.parse(response.data);
                if (isValid) {
                    this.setState({
                        isValid: true
                    });
                } else {
                    window.location.href = "/login";
                }
            })
            .catch((reason) => {
                //console.log("catch" + reason);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });

    }

    render() {
        let logBlock = (
            <div>

            </div>
        );
        if (this.state.isValid) {
            logBlock = (<AdminLogs />);
        }

        let displaySection = (
            <AzureAD provider={loginAuthProvider} forceLogin={false}>
                {({ login, logout, authenticationState, error, accountInfo }) => {
                    switch (authenticationState) {
                        case AuthenticationState.Authenticated:
                            LogRocket.identify(accountInfo.account.userName, {
                                name: accountInfo.account.name,
                            });
                            return (<div>{logBlock}</div>);
                        case AuthenticationState.Unauthenticated:
                            window.location.href = "/login";
                            return (
                                <React.Fragment>
                                    <div>Authentication Failed</div>
                                </React.Fragment>
                            );
                        default:
                            return <p>Please contact support.</p>;
                    }
                }}
            </AzureAD>
        );
        return (
            <React.Fragment>
                {displaySection}
            </React.Fragment>

        );
    }
}
